// Header.js
import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import supabase from './supabaseClient'


export default function Header({ onLogout }) {
  const location = useLocation()

  const handleLogout = async () => {
    await supabase.auth.signOut()
    onLogout()
  }

  return (
    <div style={{ display: 'flex', gap: '1rem', padding: '1rem', backgroundColor: '#f5f5f5' }}>
      <Link to="/" style={{ fontWeight: location.pathname === '/' ? 'bold' : 'normal' }}>Кабинет</Link>
      <Link to="/dealer" style={{ fontWeight: location.pathname === '/dealer' ? 'bold' : 'normal' }}>Дилер</Link>
      <button onClick={handleLogout}>Выйти</button>
    </div>
  )
}
